export function pygRange(start: number, end: number): string[] {
  return Array.from({ length: end - start + 1 }, (_, i) =>
    (start + i).toString(),
  );
}
